import React, { useState } from "react";
import { Alert, Form } from "antd";
import { Link } from "react-router-dom";
import { getErrorProps, makeRequest } from "@utils/helpers";
import { ButtonComponent, InputText } from "@comps/components";
import { forget } from "../requests";
import { Icon } from "@iconify/react";
import AuthLayout from "./AuthLayout";
import RecoverPassword from "./RecoverPassword";
import "./auth.css";

const ForgotPassword = () => {
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [sentTo, setSentTo] = useState("");

  const [form] = Form.useForm();

  const clearErrors = () => {
    setErrors([]);
    setErrorMsg("");
  };

  const onFinish = (values) => {
    clearErrors();
    makeRequest(setLoader, forget, { email: values.email }, () => onForgetSuccess(values.email), onForgetError);
  };

  const onForgetSuccess = (email) => {
    clearErrors();
    form.resetFields();
    setSentTo(email);
  };

  // An unregistered (or deactivated) address comes back as a 412 with the
  // reason in res.msg; a 422 puts the validation messages in data. Keep it
  // on screen instead of a toast that vanishes before it is read.
  const onForgetError = (data, res) => {
    const detail = Array.isArray(data) && data.length ? data[0] : null;
    const msg = detail || res?.msg || "Unable to send the reset link. Please try again.";
    setErrorMsg(msg);
    setErrors({ email: msg });
  };

  const rules = {
    email: [
      { required: true, message: "Please input your email!" },
      { type: 'email', message: "Please enter a valid email address." },
    ],
  };

  // The link has gone out — swap the form for the confirmation screen.
  if (sentTo) {
    return <RecoverPassword email={ sentTo } onResend={ () => setSentTo("") } />;
  }

  return (
    <AuthLayout
      title="Forgot password?"
      subtitle="Enter the email address you sign in with and we will send you a link to set a new password."
      footer={
        <Link className="auth-link auth-back" to="/signin">
          <Icon icon="tabler:arrow-left" width={ 16 } />
          Back to login
        </Link>
      }
    >
      { errorMsg &&
        <Alert
          className="auth-alert"
          type="error"
          showIcon
          message={ errorMsg }
        />
      }

      <Form
        form={ form }
        onFinish={ onFinish }
        className="auth-form"
        layout="vertical"
        requiredMark={ false }
        name="forgotPasswordForm"
      >
        <Form.Item
          name="email"
          onChange={ clearErrors }
          rules={ rules.email }
          label="Email address"
          { ...getErrorProps(errors['email']) }
        >
          <InputText
            placeholder="Enter your email"
            autoComplete="email"
            autoFocus
          />
        </Form.Item>

        <Form.Item className="da-mb-0">
          <ButtonComponent className="actionButton" type="primary" htmlType="submit" state={ loader }>
            Send reset link
          </ButtonComponent>
        </Form.Item>
      </Form>
    </AuthLayout>
  );
};

export default ForgotPassword;
